module.exports = __webpack_public_path__ + "img/img11.82b8f2f0.svg";